import styled, { css } from 'styled-components';

export default styled.svg`
  max-height: 1.313rem;
  color: ${({ theme }) => theme.primaryColor};
  margin-bottom: .5rem;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    margin-bottom: 0;
  }

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    margin-bottom: .5rem;
  }

  ${({ $checked }) => $checked && css`
    color: white;
  `}
`;
